import React from "react";
import ActionButton from "./ActionButton";

interface PlutoInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PlutoInfoModal: React.FC<PlutoInfoModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="absolute inset-x-0 top-0 bottom-0 z-50 flex items-center justify-center">
      <div className="relative w-full h-full max-h-full  bg-white dark:bg-gray-800 ">
        <button
          onClick={onClose}
          className="cursor-pointer absolute top-0 right-0 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <h2 className="text-xl font-bold mb-4">Why We Use Pluto </h2>
        <span className="text-xs text-text-secondary dark:text-text-secondary-dark">
          (placeholder text)
        </span>

        <div className="space-y-3 mb-6">
          <p className="text-sm">
            Pluto is a Lorem ipsum dolor sit amet, consectetur adipiscing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>

          <h3 className="font-semibold text-md mt-3">Own Your Data</h3>
          <p className="text-sm">
            With Pluto, you control what information is shared with
            applications. You can grant and revoke access at any time.
          </p>

          <h3 className="font-semibold text-md mt-3">Secure & Private</h3>
          <p className="text-sm">Secure & Private</p>
        </div>

        <div className="w-full pb-4">
          <ActionButton label="I Understand" onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

export default PlutoInfoModal;
